export default __webpack_public_path__ + "static/media/404-Graphic.63de379d.svg";